<div class="content">
    <div class="content-wrapper">


      <section class="content-header">
            <h1>
              Mein Profil
            </h1>


        </section>
        <section class="content-body card">
          <div class="form-group card-body">
            <div >
                <div class="content-body">
  
            <form [formGroup]="newForm">
                <div class="form-group">
                    <label class="control-label" for="inputVorname">Vorname</label>
                    <input type="text" class="form-control" id="inputVorname" name="Vorname"
                        placeholder="Vorname" formControlName="Vorname">
                </div>
                <div class="form-group">
                    <label class="control-label" for="inputNachname">Nachname</label>
                    <input type="text" class="form-control" id="inputNachname" name="Nachname"
                        placeholder="Nachname" formControlName="Nachname">
                </div>
                <div class="form-group">
                    <label class="control-label" for="inputEmail">E-Mail</label>
                    <input type="text" class="form-control" id="inputEmail" name="Email" placeholder="E-Mail"
                        formControlName="Email">
                </div>
                <div class="form-group" >
                    <button type="submit" class="btn btn-yellow round" style="color: black;" (click)="openModalPasswort()">Passwort Ändern</button>
                </div>
                <div class="form-group">
                    <label class="font-medium-2 text-bold-600 mr-1">2FA Deaktiviert</label>
                        
                        <ui-switch class="switchery" switchColor="white" color="rgb(55, 188, 155)" [checked]="check2fa" (change)="onChange($event)" ></ui-switch>
                        
                        <label class="font-medium-2 text-bold-600 ml-1">2FA Aktiviert</label>
                </div>
                <div class="form-group" *ngIf="check2fa">
                    <button type="submit" class="btn btn-primary btn-lg round" (click)="qrcodeModal()">QR Code</button>
                </div>
                <div class="form-group">
                    <label class="font-medium-2 text-bold-600" for="inputUserlevel">Userlevel: {{ userlevelname }}</label>
                    
                </div>
                <button type="submit" class="btn btn-success round" (click)="onSubmit()">Speichern</button>

              </form>
                </div>
            </div>
        </div>
    </section>
    </div>

  </div>
